export default {
  namespaced: true,
  state: {
    allTemplates: [
      // CMS templates
      // { id: 0, type: 'Loading', tag: 'app-template-loading' },
      { id: 1, type: 'Article', tag: 'app-template-article' },
      { id: 2, type: 'FullWidth', tag: 'app-template-fullwidth' },
      { id: 3, type: 'Home', tag: 'app-template-home' },
      { id: 4, type: '404', tag: 'app-template-404' },
      { id: 5, type: 'Results', tag: 'app-template-results' },
      { id: 15, type: 'Enquire', tag: 'app-template-enquiry' },
      { id: 68, type: 'SharedShotlist', tag: 'app-template-shared-shortlist' },
      { id: 17, type: 'Villa', tag: 'app-template-villa' },
      { id: 18, type: 'TenReasons', tag: 'app-template-tenreasons' },
      { id: 19, type: 'OurStory', tag: 'app-template-ourstory' },
      { id: 20, type: 'ThinkExquisite', tag: 'app-template-thinkexquisite' },
      { id: 21, type: 'ThinkExperiences', tag: 'app-template-thinkexperiences' },
      { id: 22, type: 'AboutUs', tag: 'app-template-aboutus' },
      { id: 23, type: 'Team', tag: 'app-template-team' },
      { id: 24, type: 'Regions', tag: 'app-template-regions' },
      { id: 82, type: 'TravelAgents', tag: 'app-template-travelagents' },
      { id: 26, type: 'Builder', tag: 'app-template-builder' },
      { id: 32, type: 'Feedback', tag: 'app-template-feedback' },
      { id: 33, type: 'Weather', tag: 'app-template-weather' },
      { id: 38, type: 'Guide', tag: 'app-template-guide' },
      { id: 41, type: 'Experience', tag: 'app-template-experience' },
      { id: 42, type: 'VillaCollections', tag: 'app-template-villacollections' },
      { id: 43, type: 'PressArticle', tag: 'app-template-pressarticle' },
      { id: 62, type: 'PressCoverage', tag: 'app-template-presscoverage' },
      { id: 63, type: 'RegionThinkExperiences', tag: 'app-template-regionthinkexperiences' },
      { id: 64, type: 'GreekIslands', tag: 'app-template-greekislands' },
      { id: 65, type: 'Country', tag: 'app-template-country' },
      { id: 66, type: 'ClientReviews', tag: 'app-template-reviews' },
      { id: 69, type: 'NewsletterSignup', tag: 'app-template-newsletter' },
      { id: 70, type: 'ExperienceGroupTier', tag: 'app-experience-group-tier' },
      { id: 83, type: 'Owner', tag: 'app-owner' },
      { id: 88, type: 'WhiteKey', tag: 'app-template-white-key' },
      { id: 94, type: 'AllVillas', tag: 'app-template-all-villas' },
      { id: 96, type: 'BookingConfirmation', tag: 'app-template-booking-confirmation' },
      { id: 97, type: 'Campaign', tag: 'app-template-campaign' },
      // Online booking checkout
      { id: 27, type: 'OBSummary', tag: 'app-template-ob-summary' },
      { id: 29, type: 'OBPayment', tag: 'app-template-ob-payment' },
      // Secure client area
      { id: 30, type: 'CALogin', tag: 'app-template-clientarea-login' },
      { id: 31, type: 'CADashboard', tag: 'app-template-clientarea-dashboard' },
      { id: 34, type: 'CABookings', tag: 'app-template-clientarea-bookings' },
      { id: 35, type: 'CAProfile', tag: 'app-template-clientarea-profile' },
      { id: 36, type: 'CAAccountSettings', tag: 'app-template-clientarea-subscriptions' },
      { id: 37, type: 'CAGuestLogins', tag: 'app-template-clientarea-guest-logins' },
      { id: 39, type: 'CABookingConditions', tag: 'app-template-clientarea-booking-conditions' },
      { id: 39, type: 'CAPrivacyPolicy', tag: 'app-template-clientarea-privacy-policy' },
      { id: 56, type: 'CAExperiences', tag: 'app-template-clientarea-experiences' },
      { id: 67, type: 'CABankAccountDetails', tag: 'app-template-clientarea-bank-account-details' },
      { id: 40, type: '3DSecure', tag: 'app-template-threed' },
      { id: 75, type: 'VillaDepositPayThanks', tag: 'ClientAreaVillaDepositThanks' },
      { id: 76, type: 'VillaBalancePayThanks', tag: 'ClientAreaVillaBalanceThanks' },
      { id: 79, type: 'CAFaq', tag: 'app-template-clientarea-FAQ' },
      { id: 80, type: 'CAWeather', tag: 'app-template-clientarea-weather' },
      { id: 81, type: 'CACarhire', tag: 'app-template-clientarea-carhire' },
      { id: 77, type: 'Greece', tag: 'Greece' },
      { id: 85, type: 'CATransfers', tag: 'app-template-clientarea-transfers' }, // 1201
      { id: 87, type: 'CABilling', tag: 'app-template-clientarea-billing' },

      { id: 89, type: 'CAExperiencesBasket', tag: 'app-template-clientarea-experiences-basket' }, // Page ID: 1224
      { id: 90, type: 'CAExperiencesCheckout', tag: 'app-template-clientarea-experiences-checkout' }, // Page ID: 1225
      { id: 91, type: 'CATransfersBasket', tag: 'app-template-clientarea-transfers-basket' }, // Page ID: 1226
      { id: 92, type: 'CATransfersCheckout', tag: 'app-template-clientarea-transfers-checkout' }, // Page ID: 1227
      { id: 93, type: 'CATransfersCompleteCheckout', tag: 'app-template-clientarea-transfers-complete-checkout' }, // Page ID: 1233

      // Secure client area - Confirmed Area
      { id: 48, type: 'CAConfirmedOrderWine', tag: 'app-template-clientarea-confirmed-order-wine' },
      { id: 49, type: 'CAConfirmedOverview', tag: 'app-template-clientarea-confirmed-overview' },
      { id: 57, type: 'CAConfirmedOrderWineStep2', tag: 'app-template-clientarea-confirmed-order-wine-step-2' },
      { id: 58, type: 'CAConfirmedOrderWinePay', tag: 'app-template-clientarea-confirmed-order-wine-pay' },
      { id: 59, type: 'CAConfirmedSummary', tag: 'app-template-clientarea-confirmed-summary' },
      { id: 60, type: 'CAConfirmedPayment', tag: 'app-template-clientarea-confirmed-payment' },
      { id: 84, type: 'FlightsAndFerries', tag: 'app-template-flights-and-ferries' },

      // Secure client area - Provisional checkout Area
      { id: 53, type: 'CAProvisionalSummary', tag: 'app-template-clientarea-provisional-summary' },
      { id: 54, type: 'CAProvisionalPayment', tag: 'app-template-clientarea-provisional-payment' },

      // Blogs
      { id: 72, type: 'BlogHome', tag: 'app-template-blog-home' },
      { id: 73, type: 'BlogTagCategoryHome', tag: 'app-template-blog-tag-category-home' },
      { id: 71, type: 'BlogArticle', tag: 'app-template-blog-article' },

    ],
  },
  getters: {
    currentTemplate: (state, getters, rootState) => {
      // get all templates from axios?
      let currentTemplate = state.allTemplates.find((o) => o.id === 0);
      if (rootState.pages.currentPage) {
        currentTemplate = state.allTemplates.find((o) => o.id === rootState.pages.currentPage.templateId);
      }
      return currentTemplate;
    },
  },
  mutations: {

  },
  actions: {

  },
};
